module.exports = __webpack_public_path__ + "img/bg-lg.4c351485.jpg";